const accessibilityModeKey = 'AccessibilityMode';
const accessibilityModeFontSizeKey = 'AccessibilityModeFontSize';
const languageKey = 'NZLanguage';

export function persistAccessibility(accessibilityMode: boolean, fontSize: number) {
  window.localStorage?.setItem(accessibilityModeKey, String(accessibilityMode));
  window.localStorage?.setItem(accessibilityModeFontSizeKey, String(fontSize));
}

export function readAccessibility(minFontSize: number) {
  const isAccessibilityMode = window.localStorage?.getItem(accessibilityModeKey) === 'true';
  const fontSize = Number.parseInt(window.localStorage?.getItem(accessibilityModeFontSizeKey) ?? '');

  return {
    isAccessibilityMode,
    fontSize: isNaN(fontSize) ? minFontSize : fontSize
  };
}

export function setHtmlFontSize(fontSize: number) {
  const html = document.getElementsByTagName('html')[0];
  html.style.fontSize = fontSize + 'pt';
}

export function readLanguage() {
  return {
    language: window.sessionStorage?.getItem(languageKey)
  };
}
